import React, { Component } from 'react';
import { Button, Modal, Label, ModalHeader, ModalBody, ModalFooter, Badge, UncontrolledTooltip } from 'reactstrap';
import _ from 'lodash';
import Select from 'react-select/async';
import { DatePicker} from '../../../../../commons/controls.js';
import { ProgressButton } from '../../../../../commons/ProgressButton';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Service from '../services';
import Loader from '../../../../../commons/loader';
import Lib from '../../../../../commons/lib';
import { PaginationTotal } from '../../../../../commons/controls';
import NetworkEmptyState from '../../../../../commons/networkemptystate';
import QueryEmptyState from '../../../../../commons/queryempty';
import DataEmptyState from '../../../../../commons/dataemptystate';
import FileSaver from 'file-saver';
import moment from 'moment';
import NumberFormatter from '../../../../../commons/NumberFormatter';
import RFForm from '../../../../../components/Form/RFForm.js';
import TimeFormatter from '../../../../../commons/TimeFormatter.js';
import SelectField from '../../../../../components/Form/SelectField.js';

class SelejtezesLista extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modalNezet: false,
      selejtezesJson: [],
      selejtezesView: {},
      modalTorles: false,
      listLoadingButton: false,
      tableStatus: 'QUERY', // [LOAD', NETW', 'LIST', 'QUERY', DATA]
      expandedItems: [],

      // FILTER VALUES
      filterMozgasdatum: new Date(), 
      filterMozgastipus: null,
      filterRaktar: null,

      pdfButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidMount() {
    this.listRaktar();
  }

  listRaktar = () => {
    Service.listRaktar(null, (err, res) => {
      if (!err) {
        const options = res[0].list;
        this.setState({ raktarJson: options });

        if(!this.state.filterRaktar && options.length > 0) {
          this.setState({ filterRaktar: options[0] }, () => this.updateTable());
        } else {
          this.updateTable();
        }
      }
    });
  }

  updateTable = () => {
    const{
      filterMozgasdatum,
      filterRaktar,
      filterMozgastipus
    } = this.state;

    let filters = {};
    filters.mozgasDatum = filterMozgasdatum ? TimeFormatter.formatDate(filterMozgasdatum) : null;
    filters.raktarId = filterRaktar ? filterRaktar.id : null;
    filters.mozgasTipus = filterMozgastipus;
    
    this.setState({ listLoadingButton: true, tableStatus: 'LOAD', expandedItems: [] }, ()=> {
      Service.listSelejtezes(filters, (err, res) => {
        if (!err) {
          let newSelejtezes = res[0];
          newSelejtezes.forEach( csokk => {
            csokk.mozgasTipus = csokk.mozgasTipus.name;
            switch(csokk.allapot.id){
              case 'FOLYAMATBAN': 
              csokk.allapot = 0; break;
              case 'NORMAL': 
              csokk.allapot = 1; break;
              case 'SZTORNO': 
              csokk.allapot = 2; break;
              case 'SZTORNOZOTT': 
              csokk.allapot = 3; break;
              default: 
              csokk.allapot = -1; break;
            }
          });
          this.setState({ 
            selejtezesJson: newSelejtezes,
            listLoadingButton: false,
            tableStatus: newSelejtezes && newSelejtezes.length > 0 ? 'LIST' : 'DATA', 
            cikkekJson: [],
            //expanded: [],
          });
        }else {
          this.setState({
            listLoadingButton: false,
            tableStatus: err && err.responseJSON && err.responseJSON.hibaazon == "EMPTY_FILTERS" ? 'QUERY' : 'NETW', 
            cikkekJson: [],
          });
          
        }
      });
    });
  }

  deleteSelejtezes = (id) => {
    this.setState({ deleteButtonLoading: true });
    Service.deleteSelejtezes(id, (err, res) => {
      if (!err) {
        this.setState({ cikkekJson: [] });
        this.updateTable();
        this.handleDeleteClick();
        this.props.globals.addSuccess('Készlet törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  handleAddKeszlet = () => {
    this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles/selejtezes/felvetel'));
  }

  handleEditClick = (id) => {
    this.props.globals.route.navigate(this.props.globals.public_url.concat('/admin/keszlet/keszletkezeles/selejtezes/modositas?id=' + id));
  }


  addSelejtezes = (event, selejtezesObj) => {
    this.setState({ selejtezesJson: [...this.state.selejtezesJson, selejtezesObj] });
    this.toggle();
  }

  handlePdfClick = (id) => {
    this.setState({ pdf: true });
    Service.generateBizonylatPdf(id, 'SELEJTEZES', (err,res)=>{
      if (!err) {
        const pdf = new Blob([res[0]], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(pdf);
        window.open(fileURL, '_blank');
      }
      this.setState({ deleteButtonLoading: true });
    });
  }

  handleDeleteClick = (id) => {
    if(id) this._currentDeleteId = id;
    this.setState({
      modalTorles: !this.state.modalTorles
    });
  }

  handleViewClick = (id) => {
    if(!this.state.modalNezet){
      Service.getSelejtezes(id, (err, res) => {
        if (!err) {
          if(id) this._currentViewId = id;
          this.setState({ 
            selejtezesView: {...res[0][0]},
            modalNezet: !this.state.modalNezet,
          });
        }
      });
    }else{
      this.setState({ 
        selejtezesView: {},
        modalNezet: !this.state.modalNezet,
      });
    }
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  hasKarb = () => {
    return this.props.globals.hasRole(['KESZLETNYILV_SELEJTEZES'], true);
  }

  iconFormatter = (cell, row) => {
    switch (row.allapot) {
      case 0: // FOLYAMATBAN
        return (
          <React.Fragment>
            <Button className="icon-eye table-action-icon" id={'selejtezes-view-' + row.allapot + '-view-' + row.id} onClick={() => this.handleViewClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'selejtezes-view-' + row.allapot + '-view-' + row.id} delay={40}> {'Megtekintés'} </UncontrolledTooltip>
            {this.hasKarb() &&
              <>
                <Button className="icon-pencil table-action-icon" id={'selejtezes-view-' + row.allapot + '-edit-' + row.id} onClick={() => this.handleEditClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'selejtezes-view-' + row.allapot + '-edit-' + row.id} delay={40}> {'Módosítás'} </UncontrolledTooltip>
                <Button className="icon-trash table-action-icon" id={'selejtezes-view-' + row.allapot + '-delete-' + row.id} onClick={() => this.handleDeleteClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'selejtezes-view-' + row.allapot + '-delete-' + row.id} delay={40}> {'Törlés'} </UncontrolledTooltip>
              </>
            }
          </React.Fragment>
        ); 
      case 1: // NORMAL
        return (
          <React.Fragment>
            {this.hasKarb() &&
              <>
                <ProgressButton loading={this.state.pdfButtonLoading} className="table-action-icon" id={'selejtezes-view-' + row.allapot + '-pdf-' + row.id} onClick={() => this.handlePdfClick(cell)}>
                  <i class="fa fa-file-pdf-o" />
                </ProgressButton>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'selejtezes-view-' + row.allapot + '-pdf-' + row.id} delay={40}> {'Bizonylat PDF generálása'} </UncontrolledTooltip>
              </>
            }
            <Button className="icon-eye table-action-icon" id={'selejtezes-view-' + row.allapot + '-view-' + row.id} onClick={() => this.handleViewClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'selejtezes-view-' + row.allapot + '-view-' + row.id} delay={40}> {'Megtekintés'} </UncontrolledTooltip>
            {this.hasKarb() &&
              <>
                <Button className="icon-trash table-action-icon" id={'selejtezes-view-' + row.allapot + '-delete-' + row.id} onClick={() => this.handleDeleteClick(cell)} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'selejtezes-view-' + row.allapot + '-delete-' + row.id} delay={40}> {'Sztornó'} </UncontrolledTooltip>
              </>
            }
          </React.Fragment>
         );
      case 2: // SZTORNO
        return (
          <React.Fragment>
            <Button className="icon-eye table-action-icon" id={'selejtezes-view-' + row.allapot + '-view-' + row.id} onClick={() => this.handleViewClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'selejtezes-view-' + row.allapot + '-view-' + row.id} delay={40}> {'Megtekintés'} </UncontrolledTooltip>
          </React.Fragment>
        );
      case 3: // SZTORNOZOTT
        return (
          <React.Fragment>
            {this.hasKarb() &&
              <>
                <ProgressButton loading={this.state.pdfButtonLoading} className="table-action-icon" id={'selejtezes-view-' + row.allapot + '-pdf-' + row.id} onClick={() => this.handlePdfClick(cell)}>
                  <i class="fa fa-file-pdf-o" />
                </ProgressButton>
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'selejtezes-view-' + row.allapot + '-pdf-' + row.id} delay={40}> {'Bizonylat PDF generálása'} </UncontrolledTooltip>
              </>
            }
            <Button className="icon-eye table-action-icon" id={'selejtezes-view-' + row.allapot + '-view-' + row.id} onClick={() => this.handleViewClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'selejtezes-view-' + row.allapot + '-view-' + row.id} delay={40}> {'Megtekintés'} </UncontrolledTooltip>
          </React.Fragment>
        );
      default:
        return ' ';
    }
  }

  tableStatusFormatter = (cell, row, enumobject) => {
    switch (cell) {
      case 0:
        return <Badge color="dark">folyamatban</Badge>;
      case 1:
        return <Badge color="success">normál</Badge>;
      case 2:
        return <Badge color="info">sztornó</Badge>;
      case 3:
        return <Badge color="primary">sztornózott</Badge>;
      default:
        return ' ';
    }
  }

  viewStatusFormatter = (cell, row, enumobject) => {
    switch (cell) {
      case 'FOLYAMATBAN':
        return <Badge color="dark">folyamatban</Badge>;
      case 'NORMAL':
        return <Badge color="success">normál</Badge>;
      case 'SZTORNO':
        return <Badge color="info">sztornó</Badge>;
      case 'SZTORNOZOTT':
        return <Badge color="primary">sztornózott</Badge>;
      default:
        return ' ';
    }
  }

  columnClassNameFormat = (fieldValue, row, rowIdx, colIdx) => {
    return row.modosithato ? 'td-column-nem-mentett' : 'td-column-mentett';
  }

  iconCikkFormatter = (cell) => {
    return (
    <div>
      <Button className="icon-eye table-action-icon" onClick={() => this.handleViewClick(cell)} />
    </div>);
  }

  szamlaFormatter = (cell) => {
    return cell ? '✓' : 'X';
  }

  onRowSelect = (row, isSelected, e) => {
    this.setState({ selectedKeszlet: row });
    Service.listKeszletCikk(row.id, (err, res) => {
      if (!err) {
        this.setState({
          expandedItems: [{id: row.id, data: res[0]}],
        });
        if (row.cikkek && !row.cikkek.length) {
            this.props.globals.addWarning('A kiválasztott tételhez nem tartoznak cikkek!');
        }
      }
    });
  }

  renderAdatok = (id) => {
    return (
      <div>
        <h6>Selejtezés információk:</h6>
        <b>Mozgás típusa: </b>{this.state.selejtezesView.mozgasTipus.name}<br />
        <b>Mozgásdátum: </b>{TimeFormatter.format(this.state.selejtezesView.mozgasDatum, "YYYY-MM-DD HH:mm:ss.SSS")}<br />
        <b>Raktár: </b>{this.state.selejtezesView.raktar.nev}<br />
        <b>Bizonylat azonosító: </b>{this.state.selejtezesView.bizonylatszam}<br />
        <b>Kapcsolódó azonosító: </b>{this.state.selejtezesView.kapcsolodoszam}<br />
        <b>Állapot: </b>{this.viewStatusFormatter(this.state.selejtezesView.allapot.id)}<br />
        <b>Megjegyzés: </b>{this.state.selejtezesView.megjegyzes}<br />
        <br />
        <b>UVD: </b>
          <div>
            <b>Rögzítés időpontja: </b>{TimeFormatter.formatDateTime(this.state.selejtezesView.uvd.rogzitesidopont)}<br />
            <b>Rögzítő személy: </b>{this.state.selejtezesView.uvd.rogzszemelynev}<br />
            <b>Módosítás időpontja: </b>{TimeFormatter.formatDateTime(this.state.selejtezesView.uvd.modositasidopont)}<br />
            <b>Módosító személy: </b>{this.state.selejtezesView.uvd.modszemelynev}<br />
            <b>Véglegezés időpontja: </b>{this.state.selejtezesView.veglegezesdatum ? TimeFormatter.formatDateTime(this.state.selejtezesView.veglegezesdatum) : ''}<br />
            <b>Véglegező személy: </b>{this.state.selejtezesView.veglegezesszemelynev}<br />
          </div>
      </div>
    );
  }

  renderFilters = () => {
    const{
      filterMozgasdatum,
      filterRaktar,
      filterMozgastipus,
    } = this.state;
    return(
      <React.Fragment>
        <RFForm onSubmit={() => {}}>
          <div className="row">
            <div className="col-md-2">
                <DatePicker
                  label="Mozgás dátuma (-tól):"
                  name="filterMozgasdatum"
                  value={filterMozgasdatum && new Date(filterMozgasdatum)}
                  onChange={(e,v) => this.handleDateInputChange(e, v, "filterMozgasdatum")}
                  max={new Date()}
                />
            </div>
            <div className="col-md-3" >
              <SelectField
                label="Raktár:"
                name="filterRaktar"
                id="filterRaktar"
                placeholder="Kezdj el gépelni a kereséshez..."
                noOptionsMessage={() => "Nincs keresési eredmény"}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => "Keresés..."}
                onChange={v => this.setState({filterRaktar: v})}
                options={this.state.raktarJson}
                value={filterRaktar}
                isClearable
                defaultOptions
                getOptionValue={option => option.id}
                getOptionLabel={option => option.nev}
              />
            </div>
            <div className="col-md-2" style={{paddingTop: "28px"}}>
              <ProgressButton color="primary" id="save" loading={this.state.listLoadingButton} onClick={e => this.updateTable(e)} >Keresés</ProgressButton>{' '}
            </div>
          </div>
        </RFForm>
      </React.Fragment>
    )
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const selectOptions = {
      AKTIV: 'Aktív',
      INAKTIV: 'Inaktív',
    };

    const selectRow = {
      mode: 'radio',
      clickToSelect: true,
      onSelect: this.onRowSelect,
      //style: { background: 'red' }
    };

    const allapotType = {
      0: 'Folyamatban',
      1: 'Normál',
      2: 'Sztornó',
      3: 'Sztornózott'
    };

    const columns = [
      {
        dataField: 'mozgasTipus',
        text: 'Mozgástípus',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'raktar.nev',
        text: 'Raktár',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'mozgasDatum',
        text: 'Mozgásdátum',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: (cell) => cell ? TimeFormatter.formatDateTime(cell) : ""
      },
      {
        dataField: 'bizonylatszam',
        text: 'Bizonylat azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'kapcsolodoszam',
        text: 'Kapcsolódó azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'allapot',
        align: 'center',
        headerStyle: { textAlign: 'center' },
        text: 'Állapot',
        filter: selectFilter({
          options: allapotType, 
          placeholder: 'Összes',
        }),
        style: {
          whiteSpace: 'pre-line',
        },
        formatter: this.tableStatusFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    const cikkColumns = [
      {
        dataField: 'cikk.cikkszam',
        text: 'Cikkszám   ',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right' 
        },
        sort: true
      },
      {
        dataField: 'cikk.megnevezes',
        text: 'Megnevezés   ',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right' 
        },
        sort: true
      },
      {
        dataField: 'mennyiseg',
        text: 'Mennyiség',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        formatter: NumberFormatter.formatterSpaceOsszeg,
        style: NumberFormatter.styleTextAlignWhiteSpace,
        sort: true
      },
      {
        dataField: 'cikk.mennyisegiEgyseg',
        text: 'Mennyiségi egység',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right' 
        },
        sort: true
      },
      {
        dataField: 'selejtezesOka',
        text: 'Selejtezés oka',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right' 
        },
        sort: true
      },
      {
        dataField: 'beszerzesnetto',
        text: 'Nettó érték',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line',
          textAlign: 'right' 
        },
        style: NumberFormatter.styleTextAlignWhiteSpace,
        formatter: (cell, row) => this.state.selectedKeszlet?.allapot == 0 ? '' : NumberFormatter.formatterSpaceOsszegPenznem(cell || 0, row),
        sort: true
      },
    ];

    const expandRow = {
      renderer: row => ( this.state.expandedItems.find(x => x.id == row.id) &&
          <React.Fragment>
            <div className="row">
              <div className="col-md-2">
                <h5>Cikkek</h5>
              </div>  
            </div>
            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-10">
                <BootstrapTable
                  bootstrap4
                  keyField="id"
                  data={this.state.expandedItems.find(x => x.id == row.id).data}
                  columns={cikkColumns}
                  //selectRow={selectRow}
                  filter={filterFactory()}
                  pagination={paginationFactory(Lib.bootstraptableProps)}
                  noDataIndication="Nincs megjelenítendő adat!"
                />
              </div>
            </div>
          </React.Fragment>
      ),
      expanded: this.state.expandedItems.map( x => x.id),
      expandByColumnOnly: true,
    };

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.selejtezesJson}
          columns={columns}
          expandRow={expandRow}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          selectRow={selectRow}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }


  render() {
    return (
      <div>
        {this.renderFilters()}

        <div className="row">
          <div className="col-md-12">
            {this.props.globals.hasRole(['KESZLETNYILV_SELEJTEZES'], true) &&
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleAddKeszlet}>Új selejtezés</Button>
            }
          </div>
        </div>

        {this.state.tableStatus === 'LOAD' ? <Loader /> : <span />}
        {this.state.tableStatus === 'QUERY' ? <QueryEmptyState hasImage /> : <span />}
        {this.state.tableStatus === 'DATA' ? <DataEmptyState hasImage subtitle="Próbálj más előszűrést vagy vigyél fel új adatokat!" /> : <span />}
        <div>
          {this.state.tableStatus === 'LIST' ? this.renderTable() : <span />}
          {this.state.tableStatus === 'NETW' ? (
          <NetworkEmptyState
            hasImage
            submitClick={() => this.updateTable()}
          />) : <span />}
        </div>

        <Modal isOpen={this.state.modalTorles} toggle={this.handleDeleteClick} className={this.props.className} backdrop="static">
          <ModalHeader >Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteButtonLoading} className="btn-cursor-pointer" color="primary" onClick={() => this.deleteSelejtezes(this._currentDeleteId)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.handleDeleteClick}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalNezet} toggle={this.handleViewClick} className={this.props.className} backdrop="static">
          <ModalHeader >Megtekintés</ModalHeader>
          <ModalBody>{this.state.modalNezet ? this.renderAdatok(this._currentViewId) : <div />}</ModalBody>
          <ModalFooter> <Button type="button" color="primary" onClick={this.handleViewClick}>Vissza</Button></ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default SelejtezesLista;
